import styles from './QuestionImgQuiz.module.css';
import { Variant } from '../../../Variant/Variant';
import { motion } from 'motion/react';

export const QuestionImgQuiz = ({
  variants,
  isStateCorrectVar,
  questionImgUrl,
  delayTransition,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.7 + delayTransition }}
      className={styles.variantsContainer}
    >
      <div className={styles.blockImgQuestion}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.5 + delayTransition }}
          src={questionImgUrl}
          alt="question img"
          className={styles.questionImg}
        />
      </div>
      <div className={styles.variants}>
        {variants?.map((item, i) => (
          <motion.div
            key={item.coment + String(i)}
            initial={{
              transform: 'scale(0)',
              opacity: 0,
              originX: 0,
              originY: 'center',
            }}
            animate={{
              transform: 'scale(1)',
              opacity: 1,
              originX: 0,
              originY: 'center',
            }}
            transition={{ duration: 1, delay: i * 0.8 + 1 + delayTransition }} // 1 анимация вопроса
          >
            <Variant
              isQuestionImg
              item={item}
              index={i}
              aciveAmimate={isStateCorrectVar && item.correct}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};
